export default {
  testingMetadata: {
    personalTesting: 'Personal testing',
    commentTitle: 'Complete your answers on this block in a free form.',
    commentDescription:
      'Only your comment will be visible in the evaluation results without specifying your name.',
    commentRequiredHint:
      '*The comment is required, the test cannot be completed without the comment.',
    commentRequiredHintScore: '*A comment is required depending on your score.',
    descriptionTitle: 'Description of the task/project',
    openQuestionsBlock: 'Open questions about the competence block',
    currentScore: 'Current score',
    // buttons
    saveAndNextButton: 'Save and next',
    closeTestingButton: 'Close testing',
    saveResultsButton: 'Save and complete the test',
    createReportSelfButton: 'Create a report',
    resetAnswersButton: 'Reset answers',
    // confirm dialogs
    confirmResetAnswers: {
      title: 'Reset answers?',
      text: 'Reset all answers of passing the skill assessment',
      button: 'Yes, reset',
    },
    // dialogs
    infoSuccessTest360Dialog: {
      title: 'The test is completed',
      defaultText: 'Your answers are saved. Thank you for your time!',
      hiddenReportText:
        'The results of the survey will be discussed at an individual meeting with the supervisor as soon as all surveys are processed.',
    },
    continuePulseTest360Dialog: {
      title: 'Do you want to go through another block?',
    },
    infoSuccessPulseTest360Dialog: {
      title: 'You have completely passed the test',
      text: 'Thank you for your time!',
    },
    testIsNotAvailableDialog: {
      title: 'The test is not available',
      finished: 'Your scores for this test session have already been saved.',
      noRole: 'You are not a participant in this assessment. Contact the evaluation organizer.',
      expired: 'The testing period has expired, please wait for the results.',
      deleted:
        'This test is not available, it may have been deleted, to find out more, contact your assessment organizer.',
      closed: 'This test was closed by the organizer.',
    },
    completedDialog: {
      title: 'The testing is completed',
      text: 'Your answers are saved.</br>Thank you for your time!',
    },
    timeIsOutDialog: {
      title: 'The time for testing is up',
      text: 'Your answers will be saved.',
    },
    restoredSessionDialog: {
      text: 'Aborted testing session has been restored',
    },
    incorrectSessionDialog: {
      title: 'An existing active session was detected',
      text: 'You have already started the test in another tab or on another device.\nTo continue the test, return to the already open tab or click the "Continue here" button - in this case, all previous test sessions will be closed. Testing will continue from where it stopped',
      button: 'Continue here',
    },
    // messages
    invalidMessage: {
      openQuestions: 'Not all required questions are filled in',
      default:
        'Required comments or questions are not filled in or not all indicators are evaluated',
    },
    successMessages: {
      saveAnswer: 'Draft saved',
      resetAnswers: 'The current score has been reset',
      saveResults: 'Your answers are saved',
    },
    errorMessages: {
      getBlock: 'Failed to get the testing data',
      getTest: 'Failed to get the test data',
      getQuestion: 'Failed to get the question data',
      getOpenQuestions: 'Failed to get the open questions',
      saveAnswer: 'Failed to save draft',
      resetAnswers: 'Failed to reset the current score',
      saveResult: 'Failed to save answer',
      saveResults: 'Failed to save answers',
      createReportSelf: 'Failed to create report',
      invalid: 'Failed to save answers. There were unanswered questions in the block',
      getDescription: 'Failed to load the description of the task/project',
      failStartTest: 'Failed to start a test session',
    },
    //
  },
};
